
define('text!plugins/textarea/template.html',[],function () { return '<div class="row">\n    <div class="large-12 small-centered columns">\n        <textarea type="text" data-rv-placeholder="model:type" data-rv-value="model:value" style="max-width: 100%"></textarea>\n        <small class="error" data-rv-show="model:hasError">{{model:errorMessage}}</small>\n    </div>\n</div>\n';});

